import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INotification } from '@shared';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BroadcastNotificationsService {
  private notificationsPath: string = `${environment.apiBasePath}${environment.notificationsPath}`;
  private broadcastPath: string = `${environment.apiBasePath}${environment.broadcastPath}`;

  constructor(private http: HttpClient) {}

  public getAll(): Observable<INotification[]> {
    return this.http.get<INotification[]>(`${this.notificationsPath}/`);
  }

  public getNotification(id: string): Observable<INotification | null> {
    return this.http.get<INotification>(`${this.notificationsPath}/${id}/`);
  }

  public getBroadcastNotification(id: string, lang = 'en'): Observable<{ body: string }> {
    return this.http.get<{ body: string }>(`${this.notificationsPath}/${id}/${lang}`);
  }

  public create(notification: INotification): Observable<any> {
    return this.http.post(`${this.notificationsPath}/`, [notification]);
  }

  public update(notification: INotification): Observable<any> {
    return this.http.put(`${this.notificationsPath}/${notification.notificationId}`, notification);
  }

  public delete(notificationId: string): Observable<any> {
    return this.http.delete(`${this.notificationsPath}/${notificationId}`);
  }

  public broadcast(notificationId: string): Observable<string> {
    return this.http.post(`${this.broadcastPath}/${notificationId}`, {}, { responseType: 'text' });
  }

  public clear(): Observable<any> {
    return this.http.delete(`${this.broadcastPath}`);
  }
}
